/**
 * Returns whether a listing should show the verified doorstep badge.
 *
 * @param {Object} listing - Listing entity or object containing attributes.metadata
 * @returns {boolean} true if doorstep or doorstepold metadata is enabled
 */
export const isDoorstepVerifiedListing = listing => {
  const metadata = listing?.attributes?.metadata || {};
  return metadata.doorstep === true || metadata.doorstepold === true;
};
